import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { followMePrincipleProfileQuery } from '@core/Areas/FollowMe/helpers/queries'

export const useShouldStartOnboarding = () => {
  const isOnboardingRef = React.useRef(false)
  const [onboardingStatus, setOnboardingStatus] = React.useState<OnboardingCheckStatus>('checking')

  const { data, isLoading } = useQuery(followMePrincipleProfileQuery)

  const hasCreatedProfile = data && data !== null && data.id

  React.useEffect(() => {
    if (isOnboardingRef.current) return

    if (hasCreatedProfile) {
      setOnboardingStatus('existing-profile')
      return
    }

    if (!hasCreatedProfile && !isLoading) {
      isOnboardingRef.current = true
      setOnboardingStatus('no-profile-found')
      return
    }
  }, [hasCreatedProfile, isLoading])

  const handleOnboardStatusSuccess = () => {
    isOnboardingRef.current = false
    setOnboardingStatus('onboarding-complete')
  }

  return { onboardingStatus, handleOnboardStatusSuccess }
}

// =====
// Types
// =====

type OnboardingCheckStatus =
  | 'checking'
  | 'existing-profile'
  | 'no-profile-found'
  | 'onboarding-complete'
